import Modal from "../../../global/components/Modal/Modal.vue";
import PuxButton from "../../../global/components/PuxButton/PuxButton.vue";
import PuxTranslate from "../../../global/components/PuxTranslate/PuxTranslate.vue";

import HttpMixin from "../../../global/mixins/HttpMixin";
import NotificationMixin from "../../../global/mixins/NotificationMixin";

// @vue/component
export default {
  name: "NutzerModalSendRegMail",
  components: {
    Modal,
    PuxButton,
    PuxTranslate,
  },
  mixins: [
    HttpMixin,
    NotificationMixin,
  ],
  props: {
    nutzer: {
      type: Object,
      default: () => ({}),
    },
    close: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      modalOptions: {
        showCloseButton: true,
      },
      status: {
        loading: undefined,
      },
    };
  },
  computed: {
    getSperrbemerkung() {
      return this.nutzer.n_sperrbemerkung || "_TXT_NUTZER_MODAL_SEND_REG_MAIL_KEINE_BEMERKUNG_";
    },
  },
  methods: {
    sendMail() {
      this.status.loading = true;
      this.postHttp({ url: `nutzer/${ this.nutzer.pk }/registrierungsmail_verschicken/` }).then(
        () => {
          this.addNotification({ text: "_MSG_NUTZER_MODAL_SEND_REGMAIL_SUCCESS_" });
          this.close();
        },
        () => this.addNotification({ text: "_MSG_NUTZER_MODAL_SEND_REGMAIL_ERROR_", type: "error" })
      ).then(
        () => this.status.loading = false
      );
    },
  },
};
